import React, { useState, ReactElement, useEffect } from 'react';
import { Hub } from 'aws-amplify';
import { CognitoUser } from '@aws-amplify/auth';
import { Link, useHistory } from 'react-router-dom';
import { Button } from '../molecules';
import { signIn } from '../../utils/auth-functions';
import { validateEmail } from '../../utils/validators';
import errorStyling from '../../utils/error-styling';
import useReturnUrl from '../../hooks/useReturnUrl';
import openEyes from '../../assets/images/open-eyes.svg';
import closeEyes from '../../assets/images/close-eyes.svg';
type Props = {
  redirectUrl?: string;
  inApp: string | null;
};

export default function LoginForm({ redirectUrl, inApp }: Props): ReactElement {
  const [email, setEmail] = useState<string | undefined>();
  const [password, setPassword] = useState<string | undefined>();
  const [emailIsValid, setEmailIsValid] = useState<boolean | undefined>(undefined);
  const [error, setError] = useState<string | undefined>(undefined);
  const [user, setUser] = useState<CognitoUser | undefined>(undefined);
  const [showPwd, setShowPwd] = useState<boolean>(false);
  const returnUrl = useReturnUrl();
  const history = useHistory();

  const handleLogin = () => {
    setError(undefined);
    if (email && password) {
      if (validateEmail({ email }) === 'valid') {
        setEmailIsValid(true);
        signIn({ username: email, password });
      } else setEmailIsValid(false);
    }
  };

  useEffect(() => {
    const cancelListen = Hub.listen('auth', (res) => {
      if (res.payload.data && res.payload.data.code) setError(res.payload.data.code);
      else {
        setUser(res.payload.data);
        setError(undefined);
      }
    });
    return () => cancelListen();
  }, []);

  useEffect(() => {
    if (inApp !== 'true' && user) {
      const goto = redirectUrl || returnUrl;
      if (goto) window.location.href = goto;
      else history.replace('/profile');
    }
  }, [user]);

  return (
    <form id="login-form">
      <div className="form-group">
        <div className="input-group">
          <input onChange={(e) => setEmail(e.target.value)} type="email" name="username" className="form-control" placeholder="Email" />
        </div>
      </div>
      {emailIsValid !== undefined && !emailIsValid && <div className="input-not-valid">Email non valida!</div>}
      <div className="form-group pwd">
        <img
          onClick={() => {
            setShowPwd(!showPwd);
          }}
          src={showPwd ? closeEyes : openEyes}
          className="eyes"
        />
        <div className="input-group">
          <input onChange={(e) => setPassword(e.target.value)} type={showPwd ? 'text' : 'password'} name="password" className="form-control" placeholder="Password" />
        </div>
      </div>
      <div className="form-group">
        <Button role="button" type={'submit'} action={() => handleLogin()} className="btn btn-primary w-100 mt-3">
          Accedi
        </Button>
      </div>
      {error !== undefined && <div className="input-not-valid text-center m-0">{errorStyling(error)}</div>}
      {error !== undefined && error === 'UserNotConfirmedException' && (
        <Link to="/confirm-user" className="btn link-override text-center m-0 w-100">
          <u>Procedi alla conferma</u>
        </Link>
      )}
    </form>
  );
}
